export var getProductPoints = function getProductPoints(_ref) {
  var _shades$find;
  var code = _ref.code,
    shades = _ref.shades;
  return shades === null || shades === void 0 || (_shades$find = shades.find(function (shade) {
    return shade.productCode === code;
  })) === null || _shades$find === void 0 ? void 0 : _shades$find.loyaltyRedeemPoints;
};
//# sourceMappingURL=getProductPoints.js.map